// Modal para adicionar um Réu existente ao processo.

import React from "react";
import axios from "axios";

const NovoReuModal = ({ idProcess, token, responsePessoa }) => {
  
    function cadastrarReu() {
        const reu = document.querySelector("#nomeReu").value;

        axios
            .post(
                `/api/new/defendant/${idProcess}`,
                { token, reu },
                {
                    withCredentials: true,
                }
            )
            .then((resp) => {
                if (resp.data == 400) {
                    alert("Essa pessoa já está cadastrada como Réu!");
                } else {
                    window.location = `/ci/pagamentos/${idProcess}`;
                }
            });
    }
    return (
        <div
            className="modal fade"
            id="novoreu"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
        >
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                            Novo Réu
                        </h5>
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <label htmlFor="m-cadastrar-descricaoLbl">
                            Selecione o Réu
                        </label>
                        <select
                            id="nomeReu"
                            className="form-control select2 select2-hidden-accessible"
                            style={{
                                width: "100%",
                                position: "static !important",
                            }}
                            name="reu"
                        >
                            {responsePessoa.map((dados, index) => (
                                <option key={index}>{dados.nome}</option>
                            ))}
                        </select>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Fechar
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={cadastrarReu}
                        >
                            Salvar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NovoReuModal;
